exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1.phd-uikit-title{font-size:7rem!important;font-weight:700!important;line-height:8rem!important}.button-table{table-layout:fixed;text-align:center}.table tbody th{text-align:left;vertical-align:middle}.table .form-group{margin-bottom:0}.table td,.table th{border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f0e53fe","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo/pages/ui-kit.vue
// module id = 1702
// module chunks = 0